import { getAccount } from '@wagmi/core';
import { isMobile } from "@layerswap/widget/internal";
export function createEVMGaslessProvider(config, supportsNetwork) {
    return {
        supportsNetwork,
        async signGaslessDeposit({ address, typedData, wallet }) {
            if (!typedData)
                throw new Error('Missing typed data for gasless deposit');
            if (!address)
                throw new Error('No selected account');
            const walletProvider = await getAccount(config).connector?.getProvider();
            if (!walletProvider?.request)
                throw new Error('Wallet provider unavailable');
            if (isMobile() && wallet?.metadata?.deepLink) {
                window.location.href = wallet.metadata.deepLink;
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            const signature = await walletProvider.request({
                method: 'eth_signTypedData_v4',
                params: [address, JSON.stringify(typedData)],
            });
            if (typeof signature !== 'string')
                throw new Error('Invalid signature returned by wallet');
            return signature;
        }
    };
}
